import { action } from '@ember/object';
import Route from '@ember/routing/route';
import type PublicTransition from '@ember/routing/transition';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

export default class GoalsCompanyRoute extends Route {
	@service('store') declare storeService: Service.Store;
	@service('model-manager/metrics') declare mmMetricsService: Service.ModelManager.Metrics;
	@service('model-manager/goals') declare mmGoalsService: Service.ModelManager.Goals;

	override beforeModel() {
		document.body.id = 'page-goals-company';
	}

	@action
	override willTransition(_transition: PublicTransition) {
		const goalRecords = this.mmGoalsService.allRecords;
		goalRecords.forEach((goal) => {
			goal.newBadge = false;
		});
	}
}
